import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import '../styles/UserDashboard.css';

// Remove trailing slash to avoid double slashes in URLs
const API_URL = (process.env.REACT_APP_API_URL || 'https://camino-backend-iooi.onrender.com').replace(/\/$/, '');

const Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading, user, getAccessTokenSilently } = useAuth0();
  const [registrationComplete, setRegistrationComplete] = useState(false);

  const registerUserInBackend = async (userInfo) => {
    try {
      console.log('🔄 Registering user in backend...');
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE
        }
      });

      const response = await fetch(`${API_URL}/api/users/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          auth0Id: userInfo.sub,
          email: userInfo.email,
          name: userInfo.name,
          picture: userInfo.picture,
          redirectUri: window.location.origin + '/callback'
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('❌ Backend registration failed:', errorData);
        throw new Error(`Failed to register user: ${errorData?.message || 'Unknown error'}`);
      }

      const data = await response.json();
      console.log('✅ User registered successfully in backend:', data);
      return data;
    } catch (error) {
      console.error('❌ Backend registration error:', error);
      // Continue anyway - the app handles this gracefully
      return { user: { auth0Id: userInfo.sub } };
    }
  };

  useEffect(() => {
    console.log("Callback page loaded with auth state:", {
      isAuthenticated,
      isLoading,
      hasUser: !!user,
      search: location.search
    });

    // After auth is complete, register user and redirect to profile
    if (!isLoading && isAuthenticated && user && !registrationComplete) {
      console.log("User authenticated, registering with backend...");

      registerUserInBackend(user).then(() => {
        setRegistrationComplete(true);
        console.log("User registration complete, redirecting to profile");
        navigate('/profile');
      }).catch((error) => {
        console.error("Registration failed, but continuing to profile:", error);
        setRegistrationComplete(true);
        navigate('/profile');
      });
    } else if (!isLoading && !isAuthenticated) {
      console.log("Auth failed, redirecting to home");
      navigate('/');
    }
  }, [isAuthenticated, isLoading, user, navigate, location, registrationComplete]);
  
  return (
    <div className="loading-container">
      <div className="loading-spinner" style={{ width: '50px', height: '50px', border: '4px solid rgba(4, 154, 99, 0.2)', borderTopColor: '#049A63', borderRadius: '50%' }} />
      <p style={{ fontSize: '1.1rem', color: '#666' }}>Bejelentkezés...</p>
    </div>
  );
};

export default Callback; 